<!-- =========================================================================================
    File Name: TableUtenti.vue
    Description: Add functionality on selecting row
    ----------------------------------------------------------------------------------------
    Item Name:
      Author:
    Author URL:
========================================================================================== -->


<template>
    <div>
        <search-bar @create="handleNew" @find="cercaUtenti" :p="{current:this.page, tot:this.tot_page}" :keyword="keyword" :newTexts="['Nuovo']" tooltip="Cognome, Nome, Email"></search-bar>
        <vs-table @next="nextPage" @prev="prevPage" :hasNext="hasNext" :custom_pager="{current:this.page, tot:this.tot_page}" pagination :max-items="elements_per_page" :page="page" v-model="selected" @selected="handleSelected($event)" :data="utenti">
            <template slot="thead">
                <vs-th>Nome</vs-th>
                <vs-th>Permessi</vs-th>
                <vs-th>Mail</vs-th>
                <vs-th>Data Attivazione</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].nome" >
                        {{[data[indextr].nome,data[indextr].cognome].join(' ')}}
                    </vs-td>

                    <vs-td :data="data[indextr].permessi">
                        {{decodePermessi[data[indextr].permessi]}}
                    </vs-td>

                    <vs-td :data="data[indextr].email">
                        {{data[indextr].email}}
                    </vs-td>

                    <vs-td :data="data[indextr].telefono">
                        {{data[indextr].data_inserimento ? $tariffe.formatDateNew(data[indextr].data_inserimento) : ''}}
                    </vs-td>

                </vs-tr>
            </template>
        </vs-table>
        <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-utenti" spacer v-model="isSidebarActive">
          <sidebar-form-utenti @close-me="sidebarClose" @elimina-utente="handleEliminaUtente($event)" @utente-salvato="handleSave" v-if="sidebar_type === 'form'" :key="formkey" :selected="selected"></sidebar-form-utenti>
        </vs-sidebar>
    </div>
</template>

<script>
import axios from 'axios'
import SidebarFormUtenti from './SidebarFormUtenti.vue'
import SearchBar from '../commons/SearchBar.vue'

export default {
    data() {
        return {
            selected: null,
            sidebar_type: '',
            sidebar_active: false,
            utenti: [],
            formkey: Math.random(),
            keyword: "",
            page: 1,
            tot_page: 0,
            hasNext: false,
            elements_per_page: 15,
            haveSaved: false,
            decodePermessi: {
              0: 'Admin',
              1: 'Responsabile',
              2: 'Utente'
            }
        }
    },
    components: {
      SidebarFormUtenti,
      SearchBar,
    },
    mounted () {
      this.getUtenti()
      // method to get array of object for utente_bacino
      this.lsbac()
    },
    methods: {
        handleSelected() {
            this.formkey = Math.random()
            this.sidebar_type = 'form'
            this.sidebar_active = true
        },

        handleNew() {
          this.sidebar_type = 'form'
          this.formkey = Math.random()
          this.selected = null
          this.sidebar_active = true
        },

        getUtenti() {
          this.activeLoading = true
          this.$vs.loading({
            type:'radius',
          })
          axios.post(process.env.VUE_APP_BACKEND_API+'/utente/trova', {
            pag: this.page,
            keyword: this.keyword,
            take: this.elements_per_page
          },{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true
          })
          .then(response => {
            if (response.data.length == 0) {  this.utenti = []
                                              this.hasNext = false }
            else {
              this.utenti = response.data.res
              this.hasNext = this.utenti.length >= this.elements_per_page
              this.tot_page = Math.ceil(response.data.count / this.elements_per_page)
              this.selected = this.selected ? this.utenti.find( a => a.id == this.selected.id) : null
            }
            this.$vs.loading.close()
          })
          .catch(e => {
            console.log(e)
            this.$vs.loading.close()
          })
        },

        nextPage() {
          if (this.page < this.tot_page) {
            this.page += 1
            this.getUtenti()
          }
        },

        prevPage() {
          this.page -= 1
          this.getUtenti()
        },

        cercaUtenti(k) {
          this.keyword = k
          this.page = 1
          this.getUtenti()
        },

        handleSave() {
          // console.log('Saved');
          this.isSidebarActive = !this.sidebar_active
          this.formkey = Math.random()

          this.sidebarClose()
          this.getUtenti()
          this.haveSaved = true

          this.page = 1
          this.keyword = ""
        },

        handleModificaUtenti() {
          this.sidebar_type = 'new'
        },

        handleEliminaUtente() {
          this.isSidebarActive = !this.sidebar_active
          this.formkey = Math.random()
          axios.post(process.env.VUE_APP_BACKEND_API+'/utente/elimina', { id: this.selected.id },{
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
            })
            .then(response => {
              this.message = response.data
              this.selected = null
              this.haveSaved = true

              this.page = 1
              this.keyword = ""
              this.getUtenti()
            } )
            .catch(e => console.log(e))
        },
        sidebarClose() {
          this.selected = null
          this.sidebar_active = false
        },
        lsbac() {
          let bac = localStorage.getItem('utente_bacino')
          // console.log(JSON.parse(bac));
        }
    },
    // watch: {
    //   sidebar_active(n, o) {
    //     console.log(n, o);
    //   }
    // },
    computed: {
      isSidebarActive: {
        get() {
          return this.sidebar_active
        },
        set(val) {
          if(!val && this.haveSaved) {
            this.haveSaved = false
          }
          else {
            this.sidebar_active = val
          }

        }
      }
    }
}
</script>
